<template>
  <div class="z-50 fixed inset-0 bg-white flex justify-center items-center">
    <div>
      <div class="flex divide-x">
        <div class="px-6">
          <h1 class="text-6xl font-bold text-cyan-600">404</h1>
        </div>
        <div class="px-6">
          <h2 class="text-5xl font-bold text-gray-900">
            ขออภัย ไม่พบหน้าที่คุณต้องการ
          </h2>
          <p class="text-xl font-medium text-gray-500">
            กรุณาตรวจสอบลิ้งค์ที่คุณเข้ามาและลองอีกครั้ง
          </p>
          <div class="mt-8 space-x-4">
            <button
              @click="goBackHome"
              type="button"
              class="
                px-4
                py-2
                border border-transparent
                rounded-md
                shadow-sm
                font-medium
                text-white
                bg-cyan-600
                hover:bg-cyan-700
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-cyan-500
              "
            >
              กลับสู่หน้าหลัก
            </button>
            <button
              type="button"
              class="
                px-4
                py-2
                border border-transparent
                rounded-md
                shadow-sm
                font-medium
                text-cyan-700
                bg-cyan-100
                hover:bg-cyan-200
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-cyan-500
              "
            >
              ติดต่อเจ้าหน้าที่
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',

  methods: {
    goBackHome() {
      this.$router.push({ name: 'Dashboard' })
    },
  },
}
</script>
